import Dialog from "../../atoms/dialog";
import DeleteAction from "../dashboardBuilder/DeleteAction";

const DeleteActionAlert = (props) => {

    const { onClose, view, onCompletion, updatedWidget } = props;


    const handleClose = () => {
        onClose()
    }

    return (
        <Dialog
            title={"Delete"}
            open={true}
            handleClose={handleClose}
        >
            <DeleteAction view={view} updatedWidget={updatedWidget} onClose={onClose} onCompletion={onCompletion} />
        </Dialog >
    )
}

export default DeleteActionAlert;